<template>
  <g class="not-copy">
    <!-- もう少し分けたい -->
    <ParentRoom v-for="i in 7" :key="i" :room="room(i)"/>
  </g>
</template>

<script>
import { mapState } from 'vuex'
import ParentRoom from '@/views/DashBoard/VirtualOffice/Room/GreenGrassOfficeR/ParentRoom'
export default {
  name: 'GreenGrassOfficeR',
  componentName: 'GreenGrassOfficeR',
  props: ['width', 'height', 'virtualOfficeRoom'],
  components: {
    ParentRoom
  },
  computed: {
    room () {
      self = this
      return function (num) {
        let ret = null
        for (const v of self.virtualOfficeRoom) {
          if (num - 1 === v.number) {
            ret = v
          }
        }
        return ret
      }
    }
  },
  data () {
    return {
      stroke: '#fff',
      strokeWidth: 10,
      fill: '#505b66',
      wholeH: 600,
      wholeW: 1400,
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/Room/GreenGrassOfficeR.vue